import { Outlet, RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';

export const routes: RouteObject[] = [
  {
    path: paths.tickets.employee.root,
    element: <Loadable component={() => import('./pages/TicketsPage')} />,
    children: [
      {
        path: paths.tickets.employee.children.details,
        element: <Outlet />,
      },
    ],
  },
  {
    path: paths.tickets.client.root,
    element: <Loadable component={() => import('./pages/TicketsPage')} />,
  },
];
